import React, { useState } from 'react';
import { useField } from 'formik';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface Props {
  name: string;
  label: string;
  [key: string]: any;
}

const QiPasswordField = (props: Props) => {
  const { label, ...rest } = props;
  const [field, meta] = useField(props);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const errorText = meta.touched && meta.error ? meta.error : '';

  return (
    <TextField
      {...field}
      {...rest}
      label={label}
      // Usamos type="text" para engañar al navegador
      type="text"
      error={!!errorText}
      helperText={errorText}
      variant="outlined"
      inputProps={{
        readOnly: true,
        autoComplete: 'one-time-code',
        style: {
          WebkitTextSecurity: showPassword ? 'none' : 'disc',
          MozTextSecurity: showPassword ? 'none' : 'disc',
          textSecurity: showPassword ? 'none' : 'disc',
        } as any,
        ...rest.inputProps,
      }}
      onFocus={(e: any) => {
        e.target.readOnly = false;
        if (rest.onFocus) rest.onFocus(e);
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="small"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        ...rest.InputProps,
      }}
    />
  );
};

export default QiPasswordField;
